import { connect } from 'react-redux';
import CohortStudents from './CohortStudents';

export default connect(null)(CohortStudents);
